import { useQuery } from "react-query";
import { clearStoredAuth } from "../utils";
import { useNavigate } from "react-router-dom";

import { API_URL } from "../config";

const fetchTransferDelayFlights = async (): Promise<LeonTransferDelayResponse> => {
  const res = await fetch(`${API_URL}/ops/leon/transfer-delay`, {
    credentials: "include",
  });

  if (!res.ok) {
    throw new Error(`${res.status}`);
  }

  return res.json();
};

const fetchFlightSnapshot = async (
  flightId: string,
): Promise<LeonEditableSnapshot> => {
  const res = await fetch(
    `${API_URL}/ops/leon/flights/${encodeURIComponent(flightId)}/snapshot`,
    { credentials: "include" },
  );

  if (!res.ok) {
    throw new Error(`${res.status}`);
  }

  return res.json();
};

export const useLeonTransferDelayFlights = () => {
  const navigate = useNavigate();

  return useQuery<LeonTransferDelayResponse, Error>(
    ["leon-transfer-delay"],
    fetchTransferDelayFlights,
    {
      refetchOnWindowFocus: false,
      retry: 1,
      refetchInterval: 60_000,
      refetchIntervalInBackground: false,
      onError: (error: Error) => {
        if (error.message === "401") {
          clearStoredAuth();
          navigate("/");
        }
      },
    },
  );
};

export const useLeonFlightSnapshot = (flightId: string | null) => {
  return useQuery<LeonEditableSnapshot, Error>(
    ["leon-flight-snapshot", flightId],
    () => fetchFlightSnapshot(flightId!),
    {
      enabled: !!flightId,
      refetchOnWindowFocus: false,
      refetchOnMount: "always",
      retry: 1,
      staleTime: 0,
    },
  );
};
